// extracted by mini-css-extract-plugin
export var btn = "P_mB B_td B_sV d_by d_bN d_bC d_dv";
export var full = "P_wK d_v d_G";